import { render, staticRenderFns } from "./SelfieSvg.vue?vue&type=template&id=93780cfa&"
import script from "./SelfieSvg.vue?vue&type=script&lang=ts&"
export * from "./SelfieSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports